import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class OsobaRadnaOpremaView extends BaseEntity{
    constructor(){
        super();
    }

    TipRadneOpreme:string = null;
    VelicinaStav:string=null;
    VelicinaSetID:number=null;
    Osoba:string=null;


    Deserialize(input:any){
        this.ID=input.ID;
        this.TipRadneOpreme=input.TipRadneOpreme;
        this.VelicinaStav=input.VelicinaStav;
        this.VelicinaSetID=input.VelicinaSetID;
        this.Osoba=input.Osoba;
        return this;
    }

    Serialize(input:OsobaRadnaOpremaView){
        return input;
    }
}